import { Modal } from '@magnetic/modal'
import { Button } from '@magnetic/button'
import { Flex } from '@magnetic/flex'
import { AwsGitHubActionsCard } from '@/components/application/AwsGitHubActionsCard'
import type { Application as ProtoApplication, Project as ProtoProject } from '@/lib/generated-types'

interface EcrGitHubActionsModalProps {
  isOpen: boolean
  onClose: () => void
  project?: Pick<ProtoProject, 'awsRoleArn' | 'ecrRegistry'> | null
  application: Pick<ProtoApplication, 'id' | 'name' | 'ecrRegistry' | 'ecrRepositoryName'>
}

export function EcrGitHubActionsModal({
  isOpen,
  onClose,
  project,
  application,
}: EcrGitHubActionsModalProps) {
  const awsRoleArn = project?.awsRoleArn ?? ''
  if (!awsRoleArn) return null

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
    >
      <Modal.Content>
        <Flex direction="vertical" style={{ padding: 24, maxHeight: '85vh', overflow: 'auto' }}>
          <AwsGitHubActionsCard project={project} application={application} />
          <Flex style={{ marginTop: 24 }} justify="flex-end">
            <Button kind="primary" onClick={onClose}>
              Close
            </Button>
          </Flex>
        </Flex>
      </Modal.Content>
    </Modal>
  )
}
